import React from "react";

const STAGE_COLORS = {
  "New": "bg-blue-50 text-blue-700 border-blue-200",
  "Junk": "bg-slate-100 text-slate-600 border-slate-200",
  "Not Connected": "bg-slate-100 text-slate-700 border-slate-200",
  "Follow-up": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Interested": "bg-amber-50 text-amber-700 border-amber-200",
  "Not-Interested": "bg-rose-50 text-rose-700 border-rose-200",
  "Contact-in-Future": "bg-violet-50 text-violet-700 border-violet-200",
  "Agreement In-Process": "bg-orange-50 text-orange-700 border-orange-200",
  "Onboarding-in-Process": "bg-orange-100 text-orange-800 border-orange-300",
  "Live": "bg-emerald-50 text-emerald-700 border-emerald-200",
};

const TAG_COLORS = {
  Hot: "bg-red-50 text-red-700 border-red-200",
  Warm: "bg-amber-50 text-amber-700 border-amber-200",
  Cold: "bg-blue-50 text-blue-700 border-blue-200",
  Lost: "bg-slate-100 text-slate-700 border-slate-200",
};

export function StageBadge({ stage }) {
  const cls = STAGE_COLORS[stage] || "bg-slate-100 text-slate-700 border-slate-200";
  return (
    <span
      data-testid={`stage-badge-${(stage || "").toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${cls}`}
    >
      {stage || "—"}
    </span>
  );
}

export function TagBadge({ tag }) {
  if (!tag) return null;
  const cls = TAG_COLORS[tag] || "bg-slate-100 text-slate-700 border-slate-200";
  return (
    <span
      data-testid={`tag-badge-${tag.toLowerCase()}`}
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${cls}`}
    >
      {tag}
    </span>
  );
}
